import { render } from "./NewAccountActivation.vue?vue&type=template&id=7940850e"
import script from "./NewAccountActivation.vue?vue&type=script&lang=js"
export * from "./NewAccountActivation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__